<template>
  <div class="space-y-8 pb-16">
    <BaseCard v-if="isPending">
      <BaseCardBody> Campaign is scheduled to begin {{ startsAtHumanReadable }} </BaseCardBody>
      <BaseCardBody>
        <ManageSmsCampaignStatus :sms-campaign="smsCampaign" />
      </BaseCardBody>
    </BaseCard>
    <BaseCard v-if="isQueued">
      <BaseCardBody> Campaign is on queue </BaseCardBody>
      <BaseCardBody>
        <ManageSmsCampaignStatus :sms-campaign="smsCampaign" />
      </BaseCardBody>
    </BaseCard>
    <BaseCard v-if="isRunning">
      <BaseCardBody> Campaign is running </BaseCardBody>
      <BaseCardBody>
        <ManageSmsCampaignStatus :sms-campaign="smsCampaign" />
      </BaseCardBody>
    </BaseCard>
    <BaseCard v-else-if="isCancelled">
      <BaseCardBody> Campaign has been cancelled </BaseCardBody>
      <BaseCardBody>
        <ManageSmsCampaignStatus :sms-campaign="smsCampaign" />
      </BaseCardBody>
    </BaseCard>
    <BaseCard v-else-if="isFailed">
      <BaseCardBody>
        <p>Campaign failed to start.</p>
        <p v-if="smsCampaign.error" class="mt-2 text-red-500">
          {{ smsCampaign.error }}
        </p>
      </BaseCardBody>
      <BaseCardBody>
        <ManageSmsCampaignStatus :sms-campaign="smsCampaign" />
      </BaseCardBody>
    </BaseCard>
    <SmsCampaignStats v-if="isCompleted" :sms-campaign="smsCampaign" />
    <DeliveryStats :sms-campaign="smsCampaign" />
  </div>
</template>

<script>
import moment from 'moment';
import ManageSmsCampaignStatus from './components/ManageSmsCampaignStatus.vue';
import SmsCampaignStats from './components/SmsCampaignStats.vue';
import DeliveryStats from './components/DeliveryStats.vue';

export default {
  components: {
    ManageSmsCampaignStatus,
    SmsCampaignStats,
    DeliveryStats,
  },
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPending() {
      return this.smsCampaign.status === 'PENDING';
    },
    isQueued() {
      return this.smsCampaign.status === 'QUEUED';
    },
    isRunning() {
      return this.smsCampaign.status === 'RUNNING';
    },
    isCompleted() {
      return this.smsCampaign.status === 'COMPLETED';
    },
    isCancelled() {
      return this.smsCampaign.status === 'CANCELLED';
    },
    isFailed() {
      return this.smsCampaign.status === 'FAILED';
    },
    startsAtHumanReadable() {
      const { starts_at: startsAt } = this.smsCampaign;

      if (!startsAt) {
        return 'N/A';
      }

      const to = moment.utc(this.smsCampaign.starts_at).local();

      return moment().to(to);
    },
  },
};
</script>
